const registration = {
    RUNNING: 0,
    CREATED: 1,
    COMPLETED: 2,
    LOCKED: 3,
    ERROR: 9,
    name: {
        0: "RUNNING",
        1: "CREATED",
        2: "COMPLETED",
        3: "LOCKED",
        9: "ERROR",
    }
  };
  
  export default registration;
  